import React from 'react';
import { Icon } from '@fourthwall/components';
import { ExclamationMarkIcon } from '@fourthwall/icons';
import * as S from './styled';
export const ForbiddenRouteState = ({ title = 'Page not found', subtitle = 'The page you’re looking for doesn’t exist or you don’t have permissions to access it.', }) => (React.createElement(S.Container, null,
    React.createElement(Icon, { component: ExclamationMarkIcon, height: 30 }),
    React.createElement(S.Title, null, title),
    React.createElement(S.Subtitle, null, subtitle)));
